import { PutUnifiedShellOptOutRequest, PutUnifiedShellOptOutResponse } from '../../../../common/iam/users/api-types';
import {
  ExternalApiTokenResponse,
  RequestCreateUsers,
  RequestFinalizeUser,
  RequestForgotPassword,
  RequestFreemiumResendVerification,
  RequestFreemiumSignup,
  RequestLogin,
  RequestPasswordReset,
  RequestSignup,
  RequestVerifyUser,
  ResponseCreateUsers,
  ResponseFreemiumSignup,
  ResponseLogin,
  ResponseSignup,
  ResponseVerifyUser,
  UpdateUserRequest,
  User,
  UserPlain,
} from '../../../../common/iam/users/types';
import { SuccessOrError } from '../../../../common/types-api';
import { fetchOrThrow } from '../../common/fetchers/fetch-or-throw';
import { fetchApiWithError, requestApiWithError } from '../../common/fetchers/fetch-with-error';

export async function forgotPassword(email: string) {
  const body: RequestForgotPassword = { email };
  return await requestApiWithError<any>('/forgot-password', 'POST', body);
}

export async function resetPassword(code: string, password: string) {
  const body: RequestPasswordReset = { code, password };
  return await requestApiWithError<ResponseLogin>('/reset-password', 'POST', body);
}

export async function signup(options: RequestSignup) {
  return await requestApiWithError<ResponseLogin>('/user', 'POST', options);
}

export async function freemiumSignup(options: RequestFreemiumSignup) {
  return await requestApiWithError<ResponseFreemiumSignup>('/freemium-user', 'POST', options);
}

export async function resendFreemiumVerification(options: RequestFreemiumResendVerification) {
  return await requestApiWithError<{ sent: boolean }>('/freemium-user/resend-verification', 'POST', options);
}

export async function createUsers(body: RequestCreateUsers) {
  return await fetchOrThrow<ResponseCreateUsers>('/users', 'POST', body);
}

export async function getUser(username: string) {
  const response = await fetchApiWithError<User>(`/user/${username}`);
  return response;
}

export async function fetchOwnInfo() {
  return await requestApiWithError<User>('/own-info', 'GET');
}

export async function putUnifiedShellOptOut(optOut: boolean) {
  const body: PutUnifiedShellOptOutRequest = { optOut };
  return await fetchOrThrow<PutUnifiedShellOptOutResponse>('/user/unified-shell-opt-out', 'PUT', body);
}

export async function fetchUserForFinalization(username: string, code: string) {
  return await requestApiWithError<UserPlain>(`/user/finalize/${username}/${code}`);
}

export async function finalizeUser(username: string, body: RequestFinalizeUser) {
  return await fetchOrThrow<ResponseSignup>(`/user/finalize/${username}`, 'POST', body);
}

export async function updateUser(userId: number, body: UpdateUserRequest) {
  return await fetchOrThrow<ResponseSignup>(`/user/${userId}`, 'PUT', body);
}

export async function deleteUser(username: string) {
  return await fetchApiWithError<SuccessOrError>(`/user/${username}`, 'DELETE');
}

export async function resetExternalAPIToken() {
  return await fetchApiWithError<ExternalApiTokenResponse>(`/user/reset-api-token`, 'POST');
}

export async function login(email: string, password: string) {
  const body: RequestLogin = { email, password };
  return await requestApiWithError<ResponseLogin>('/login', 'POST', body);
}

export async function logout() {
  return await requestApiWithError<SuccessOrError>('/logout', 'POST');
}

export async function verifyUser(body: RequestVerifyUser) {
  return await fetchOrThrow<ResponseVerifyUser>(`/verify`, 'POST', body);
}

export async function acceptInvitation(invitationId: string) {
  return await fetchOrThrow<SuccessOrError>(`/user-groups/invitations/${invitationId}/accept`, 'POST');
}
